import { getAppStore, handleError, onAuthLogout } from '..';
import { Log } from '../../../logging/src';
import { aadConfig } from '../../config/pubCenterAAD.config';
import { getPublisherId } from '../../pages/report/@data/store/store';
import { fetchPubCenterAADAccessTokenAsync } from '../services/PubCenterAADAuthService';
import { UserContext } from '../store/schema';
import { TokenType } from '../store/schema/enums/TokenType';

const tokenHeaderMap = {
  [TokenType.SessionGuid]: 'CommonSessionId',
  [TokenType.PubCenterAADToken]: 'PubCenterAuthenticationToken',
};

export async function buildRequestHeadersWithAuthToken(
  url: string,
  userContext?: UserContext,
  includeDefaultHeaders = true
): Promise<Headers> {
  if (!userContext) {
    userContext = getAppStore().userContext;
  }

  const defaultHeaders = [['content-type', 'application/json']];
  const tokenHeader = tokenHeaderMap[TokenType.PubCenterAADToken];
  const token = await fetchPubCenterAADAccessTokenAsync();

  if (userContext && token) {
    const headers = new Headers([[tokenHeader, token]]);

    // include default headers
    if (includeDefaultHeaders) {
      defaultHeaders.forEach((header) => headers.append(header[0], header[1]));
    }

    // Add custom headers for all mediation requests
    if (url.includes('preauth')) {
      headers.append('PublisherIds', getAppStore().publisher!.id.toString());
      headers.append('AccountIds', getAppStore().account!.id.toString());
    }

    // Add custom headers for all pub center reporting requests
    if (url.includes('api/report') || url.includes('api/metadata')) {
      headers.append('TargetCustomerId', getPublisherId());
    }

    headers.append('DevToken', aadConfig.auth.devToken.toString());

    return headers;
  } else {
    Log.error('User not logged in or authentication failed');
    onAuthLogout();

    return handleError(new Error('Invalid login, please login'), url);
  }
}
